import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import router from '../router'

Vue.use(Vuex)

Vue.use(VueAxios, axios)
import { objectToFormData } from 'object-to-formdata';

var _ = require('lodash');

export default new Vuex.Store({
  state: {
    isLoading: false,
    currentStepComponent: 'step1',
    currentSubStepComponent: null,
    currentStepNumber: 1,
    stepsCount: 0,
    finish: false,
    answers: {},
    client:{}
  },
  mutations: {
    setLoader(state, data) {
      state.isLoading = data;
    },
    setCurrentStepComponent(state, data) {
      state.currentStepComponent = data;
    },
    setCurrentSubStepComponent(state, data) {
      state.currentSubStepComponent = data;
    },
    setCurrentStepNumber(state, data) {
      state.currentStepNumber = data;
    },
    setStepsCount(state, data) {
      state.stepsCount = data;
    },
    setFinish(state, data) {
      state.finish = data;
    }
  },
  actions: {
    answer({
      commit,
      state
    }, data) {
      if (data.step && data.answer) {

        if (data.finish) {
          commit('setFinish', true);
          // window.history.pushState(null, null, 'https://motorpol.philou.me/?end=1');
        }

        if (data.substep) {
          if (data.asSubstep) {
            _.extend(state.answers, {
              [data.substep]: data.answer
            });
            data.step++;
            commit('setCurrentStepComponent', 'step' + data.step);
            commit('setCurrentStepNumber', data.step);
            commit('setCurrentSubStepComponent', '');
          } else {
            _.extend(state.answers, {
              [data.step]: data.answer
            });
            commit('setCurrentSubStepComponent', 'substep' + data.substep);
          }
        } else {
          _.extend(state.answers, {
            [data.step]: data.answer
          });
          if (data.goToStep) {
            commit('setCurrentStepComponent', 'step' + data.goToStep);
            commit('setCurrentStepNumber', data.goToStep);
          } else {
            data.step++;
            commit('setCurrentStepComponent', 'step' + data.step);
            commit('setCurrentStepNumber', data.step);
          }
        }
        return true;
      } else {
        return false;
      }
    },
    closeSubStep({
      commit,
      state
    }) {
      commit('setCurrentSubStepComponent', '');
    },
    submitAnswer({
        state
      }) {
      axios.post('https://skodadelivery.showmethecar.online/api/mobile/save-first-survey', objectToFormData({
          zws_number: state.client.zwsNumber,
          po_number: state.client.poNumber,
          survey: state.answers
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Mobile-Token': 'FXVrZjlFwo3zvjlhSZcxvhmyBIWgeBuD1KpKMPjkfOzhHRc1u1hG0UHwvP6CASnkL899qKblU6sEtQy8tyuoCGk0Nh7lbm6Sme6p'
          }
        }
      ).then(function (response) {
        router.push('finish');
      }).catch(function (error) {
        console.log(error);
      });
    },
    paseQueryString({
      state
    }){
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      state.client = {
        'zwsNumber': urlParams.get('zwsNumber'),
        'poNumber': urlParams.get('poNumber')
      };

      if ((!urlParams.get('zwsNumber') && !urlParams.get('poNumber')) && !urlParams.get('end')){
        window.alert('zwsNumber and poNumber are not provided!');
      }
    }
  },
  getters: {
    getLoader: state => state.isLoading,
    getCurrentStepComponent: state => state.currentStepComponent,
    getCurrentStepNumber: state => state.currentStepNumber,
    getStepsCount: state => state.stepsCount,
    getAnswers: state => state.answers,
    getFinish: state => state.finish
  },
  strict: false
});
